module.exports = __webpack_public_path__ + "static/media/cuentapublica.383bad74.webp";